import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { GepjarmuLayoutComponent } from './layout/layout.component';
import { GjKezdolapComponent } from './kezdolap/kezdolap.component';
import { GjJarmuvekComponent } from './jarmuvek/jarmuvek.component';
import { GjSoforokComponent } from './soforok/soforok.component';
import { GjCimtarComponent } from './cimtar/cimtar.component';
import { GjKoltsegekComponent } from './koltsegek/koltsegek.component';
import { GjBeallitasokComponent } from './beallitasok/beallitasok.component';
import { GjUtnyilvantartasComponent } from './utnyilvantartas/utnyilvantartas.component';
import { GjUtGpsComponent } from './ut-gps/ut-gps.component';
import { GjElszamolasComponent } from './elszamolas/elszamolas.component';
import { GjKikuldetesComponent } from './kikuldetes/kikuldetes.component';
import { GjCegautoadoComponent } from './cegautoado/cegautoado.component';
import { ProfilMenuComponent } from '../components/profil-menu/profil-menu.component';
import { UgyfelkorBeallitasComponent } from '../components/ugyfelkor-beallitas/ugyfelkor-beallitas.component';
import { SzerkZarSavComponent } from '../components/szerk-zar/szerk-zar-sav.component';

// GÉPJÁRMŰ (GEPJARMU) – önálló alrendszer: járműtörzs, útnyilvántartás, km-elszámolás, kiküldetés, költségek
// és lejáratok, cégautóadó (backend: gepjarmu*.js – /api/gepjarmu, /api/gepjarmu-ut, /api/gepjarmu-ado).
// Arculat: közúti tábla-kék (#1e5aa8).
const K = [GepjarmuLayoutComponent, GjKezdolapComponent, GjJarmuvekComponent, GjSoforokComponent, GjCimtarComponent, GjKoltsegekComponent, GjBeallitasokComponent, GjUtnyilvantartasComponent, GjUtGpsComponent, GjElszamolasComponent, GjKikuldetesComponent, GjCegautoadoComponent];
@NgModule({
  declarations: K,
  imports: [CommonModule, FormsModule, RouterModule, IonicModule, ProfilMenuComponent, UgyfelkorBeallitasComponent, SzerkZarSavComponent],
  exports: K,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GepjarmuModule {}
